
const Modal = require('app/ui/Modal');

const ProductCreateForm = require('app/restaurant/analyse/product/Form');

class CreateModal {
    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': "title",
            'analyse': null,
            'invoice': null,
            'productAssociation': null,

            'onSuccess': function(productAssociation){},
            'onClose': function(event){},
            'onShown': function(event){}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.analyse = this.settings.analyse;
        if(!this.analyse.id){
            window.notify("Missing analyse object in ProductCreateModal","danger");
        }

        this.invoice = this.settings.invoice;
        this.productAssociation = this.settings.productAssociation;
        if(!this.productAssociation){
            window.notify("Missing productAssociation object in ProductCreateModal","danger");
        }


        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-analyse-product-create-modal')
        .append(this.buildForm());

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })
        this.modal.show();
            

    }


    buildForm(){
        var self = this;
        this.form = new ProductCreateForm({
            'analyse': this.analyse,
            'productAssociation': this.productAssociation,
            'success': function(data){
                self.onSuccess(data);
            },
            'onCancel': function(){
                self.modal.dispose();
            }
        });

        this.$form = this.form.getForm();

        return this.$form;
    }

    onSuccess(data){
        this.modal.dispose();
        this.settings.onSuccess(data.productAssociation);
    }
}

module.exports = CreateModal;

